import { useQuery } from "react-query";
import { getOfficeImageLabel } from "../../../../actions/CarrierAgreementMgmt/OfficeSettings";

export const useGetOfficeImageLabel = () => {
  return useQuery("OfficeImageLabel", getOfficeImageLabel, {
    refetchOnWindowFocus: false,
  });
};
